<template>
  <div>
    <video ref="videoPlayer" class="video-js" lang="es"></video>
  </div>
</template>

<script>
import utilitiesMixin from '../../mixins/utilitiesMixin'
import videoEventsMixin from '../../mixins/videoEventsMixin'
import videoResumeMixin from '../../mixins/videoResumeMixin'
import videojs from 'video.js'
import es from 'video.js/dist/lang/es.json'
// El es.json de video.js solo cubre las cadenas del núcleo (Play, Pause, Fullscreen...).
// Nuevo y nuestro plugin pasan las suyas por player.localize(), que al no encontrarlas devuelve
// el inglés tal cual, así que hay que aportarlas nosotros. Ver nuevo-es.json y proeduca-es.json.
import nuevoEs from '../../videojs/lang/nuevo-es.json'
import proeducaEs from '../../videojs/lang/proeduca-es.json'
import settings from '../../setttings'
require('../../videojs/plugins/nuevo')
require('../../videojs/plugins/videojs-proeduca-chat')

export default {
  name: 'VideoPlayer',
  mixins: [utilitiesMixin, videoEventsMixin, videoResumeMixin],
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    },
    trackOptions: {
      type: Object,
      default () {
        return {}
      }
    },
    chat: null
  },
  data () {
    return {
      player: null
    }
  },
  mounted () {
    let vueComponent = this
    this.options.language = 'es'
    this.options.languages = {
      es: { ...es, ...nuevoEs, ...proeducaEs }
    }
    this.options.playbackRates = [0.5, 1, 1.5, 2]
    // Licencia del plugin Nuevo. En localhost va vacía: el plugin no la exige.
    this.options.license = settings ? settings.NUEVO_LICENSE : ''
    this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady () {
      console.log('onPlayerReady', this)
    })
    // Los tracks (subtítulos y capítulos) se cargan con loadTracks() de Nuevo en vez de con
    // addRemoteTextTrack() porque es la vía que engancha los capítulos: Nuevo escucha el 'load' del
    // VTT y solo entonces pinta los marcadores de la barra y el panel de capítulos. Se hace en
    // 'loadeddata' —como indica su documentación— porque los marcadores se posicionan en porcentaje
    // sobre player.duration(), que antes no se conoce y dejaría la barra sin marcas. loadTracks()
    // reemplaza los tracks que hubiera, así que subtítulos y capítulos van en la misma llamada.
    let tracks = []
    if (this.trackOptions.src) {
      tracks.push(this.trackOptions)
    }
    // El VTT de capítulos solo existe si la grabación tiene resumen; el backend manda null si no.
    if (this.recording && this.recording.chaptersUrl) {
      tracks.push({kind: 'chapters', src: this.recording.chaptersUrl, srclang: 'es', label: 'Capítulos'})
    }
    if (tracks.length) {
      this.player.one('loadeddata', function () {
        vueComponent.player.loadTracks(tracks)
      })
    }
    // Nuevo se inicializa el primero: reconstruye la barra de control, y los
    // botones que añaden los plugins siguientes deben colocarse sobre la final.
    this.player.nuevo({
      // El skin oculta el selector de velocidad nativo; Nuevo lo ofrece desde
      // su menú de ajustes, que es donde se ven los playbackRates de arriba.
      rateMenu: true,
      // Sin la opción de compartir del menú de ajustes: enlaza a redes sociales con la URL
      // de la página, que aquí es la del LTI dentro del LMS y no lleva a ningún sitio útil.
      // El botón de ajustes sigue apareciendo porque rateMenu lo mantiene.
      shareMenu: false,
      // La reanudación la lleva videoResumeMixin contra nuestro backend.
      resume: false,
      // Retroceso/avance de Nuevo, en sustitución de videojs-seek-buttons.
      // Salta 10s, el mismo valor que devolvía seekPlayerTimeSeconds().
      // El de avance viene desactivado de fábrica y hay que pedirlo.
      buttonRewind: true,
      buttonForward: true,
      // Marcas de capítulo sobre la barra de progreso (con el título del capítulo en el tooltip).
      // Viene activado de fábrica, se deja explícito por ir junto al panel de abajo.
      chapterMarkers: true,
      // Panel lateral con la lista de capítulos, que sustituye al menú desplegable nativo de
      // video.js. Cada capítulo se numera porque nuestro VTT no trae miniaturas: Nuevo usa el
      // identificador de la cue como URL de la miniatura y, al no haberla, cae en el número.
      // Ambas opciones son inertes si la grabación no tiene VTT de capítulos.
      chaptersList: true
    })
    this.player.proeducaChat({
      chat: this.chat,
      // La pestaña de transcripción se monta a partir de las cues de este mismo track de subtítulos;
      // aquí solo se le dice al panel si la grabación tiene VTT o no.
      captions: this.trackOptions.src,
      // El panel muestra el resumen en una pestaña aparte, que solo aparece si la grabación
      // tiene uno. El objeto recording llega desde la tarjeta que lanzó la reproducción.
      summary: this.recording ? this.recording.summary : null
    })
  },
  beforeDestroy () {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Player/VideoPlayer.vue